// NATIVE 
import React, { useEffect, useState } from 'react';


// INSTALLED 
import { useFormikContext } from 'formik';
import Divider from '@mui/material/Divider';
import { Button, Card, CardActionArea, CardMedia, Grid } from '@mui/material';


// CUSTOM 
import { useDispatch, useSelector } from 'react-redux';
import { UploadButtonField } from '../../formFields/uploadButtonField';
import { uploadImgStore } from '../../../store/uploaders';
import { LinearProgressWithLabel } from '../../LinearProgressWithLabel';
import {  CardActionImage } from '../../CardActionImage';



/**
 * LogosRazonSocialEditar component allows users to upload and preview logos for "Razon Social" and "Post Razon Social".
 * It uses Formik for form state management and Redux for state management.
 * 
 * @param {any} props - The properties passed to the component.
 * @param {object} props.formField - The form fields for the logos.
 * @param {object} props.formField.e_logo_company - The form field for the "Razon Social" logo.
 * @param {object} props.formField.e_logo_post_company - The form field for the "Post Razon Social" logo.
 * 
 * @returns {JSX.Element} The rendered component.
 * 
 * @component
 * 
 * @example
 * return (
 *   <LogosRazonSocialEditar formField={{ e_logo_company: { name: 'logo_company', label: 'Logo Company' }, e_logo_post_company: { name: 'logo_post_company', label: 'Logo Post Company' } }} />
 * )
 * 
 * @remarks
 * This component uses the following hooks:
 * - `useDispatch` from `react-redux` to dispatch actions.
 * - `useFormikContext` from `formik` to access Formik context.
 * - `useSelector` from `react-redux` to select state from the Redux store.
 * - `useState` from `react` to manage local state.
 * - `useEffect` from `react` to perform side effects.
 * 
 * The component handles the following functionalities:
 * - Uploading and previewing the "Razon Social" logo.
 * - Uploading and previewing the "Post Razon Social" logo.
 * - Displaying progress bars for the upload processes.
 * - Fetching and displaying existing logos from the server.
 */
export const LogosRazonSocialEditar = (props:any) => {

      
      // USE DISPATCH 
      const dispatch = useDispatch();


      // USE FORMIK CONTEXT 
      const formikProps:any = useFormikContext();


      // USE SELECTOR 
      const { company }:any  = useSelector( (state:any) => state.company );


      // USE STATE 
      const [logoUrlRazonSocial, setLogoUrlRazonSocial] = useState('');
      const [logoUrlPostRazonSocial, setLogoUrlPostRazonSocial] = useState('');


      const [preview_rz_logo, setPreviewRzLogo] = useState('');
      const [file_n_rz_name, setLogoRzFileName] = useState('');
      const [file_logo_comercial, setFileRzLogo] = useState(null);
      const [percentage_rz_upload_logo, setPercentageRzUploadLogo] = useState(0);


      const [percentage_rz_upload_post, setPercentageRzUploadPost] = useState(0);
      const [file_logo_post, setFileRzPost] = useState(null);
      const [preview_rz_post, setPreviewRzPost] = useState('');
      const [file_post_name, setPostFileName] = useState('');




      // FORM FIELD 
      const { formField: {
        e_logo_rz_company,
        e_logo_post_rz_company
      }
    } = props;

   
    


    // USE EFFECT 
    // VERIFICA QUE SI ESTA DEFINIDO EN EL FORMIK LOS LOGOS LOS PONE 
    // PORQUE EL STEPER LO BORRA AL VOLVER 
    useEffect(() => {
      
      if ( formikProps.values.e_logo_rz_company && formikProps.values.e_logo_rz_company instanceof File ) {
          const objectURL = URL.createObjectURL(formikProps.values.e_logo_rz_company);
          setPreviewRzLogo(objectURL);
          setPercentageRzUploadLogo(100);
      }

      if ( formikProps.values.e_logo_post_rz_company && formikProps.values.e_logo_post_rz_company instanceof File ) {
          const objectURL = URL.createObjectURL(formikProps.values.e_logo_post_rz_company);
          setPreviewRzPost(objectURL);
          setPercentageRzUploadPost(100);
      }

    }, []);



    useEffect(() => {

      getLogoCompanyRazonSocial(company.logo_bn_rz_company);
      getLogoPostCompanyRazonSocial(company.logo_bn_rz_post_company);

    }, []);



    const getLogoCompanyRazonSocial = async(imageName:string) => { 
      setLogoUrlRazonSocial(imageName);
    }


  
    const getLogoPostCompanyRazonSocial = async(imageName:string) => { 
         setLogoUrlPostRazonSocial(imageName);
    }


    const uploadFileLogo = async({ target }:any) => {
   
      
      const { name } = target.files[0];

      setLogoRzFileName(name);
      setFileRzLogo(target.files[0]);

      const objectURL = URL.createObjectURL(target.files[0]);
      setPreviewRzLogo(objectURL);
  
      formikProps.setFieldValue('e_logo_rz_company', target.files[0]);
      const { ok, data } = await dispatch( uploadImgStore( 'image-company', target.files[0], setPercentageRzUploadLogo) );
    
      if (ok) {
         formikProps.setFieldValue('logoCompanyRazonSocialChange', true);
         formikProps.setFieldValue('e_logo_rz_company_name_saved_file', data.imgName);
      }


    }

    const uploadFileLogoPost = async({ target }:any) => {
   
      
      const { name } = target.files[0];
      setPostFileName(name);
      setFileRzPost(target.files[0]);

      const objectURL = URL.createObjectURL(target.files[0]);
      setPreviewRzPost(objectURL);
  
      formikProps.setFieldValue('e_logo_post_rz_company', target.files[0]);
      const { ok, data } = await dispatch( uploadImgStore( 'image-company', target.files[0], setPercentageRzUploadPost) );
      if (ok) {
        formikProps.setFieldValue('logoPostRazonSocialCompanyChange', true);
        formikProps.setFieldValue('e_logo_post_rz_company_name_saved_file', data.imgName);
      }

    }


  return (
    <div>
        <Grid container spacing={2}>
            <Grid size={{ xs: 6 }}>
                <Button>  Sube Tu Logo Razon Social</Button>
                <Divider/>
                <UploadButtonField onChange={uploadFileLogo} 
                                   accept={'image/*'} 
                                   name={e_logo_rz_company.name} 
                                   label={e_logo_rz_company.label} 
                                   text={'Subir Archivo'} />
                {
                  formikProps.values.logoCompanyRazonSocialChange 
                       ?
                       <>
                        <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                          <Card sx={{ maxWidth: 350, marginTop: 7 }}>
                          <CardActionArea>
                            <CardMedia
                              component="img"
                              height="250"
                              sx={{ objectFit: 'contain' }}
                              image={preview_rz_logo}
                              alt="green iguana"
                            />
                          </CardActionArea>
                        </Card>
                        </div>
                        <Card variant="elevation" sx={{  marginTop: 1.5, padding: 1, height: '70%',  }}>
                           <LinearProgressWithLabel percentage={percentage_rz_upload_logo} label={formikProps.values.e_logo_rz_company.name} hasIcon={false} />
                        </Card>
                       </>
                       :
                        <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                          <CardActionImage urlImage={formikProps.values.e_logo_rz_company} typeImage={'company'} />
                        </div>
                }
            </Grid>
            <Grid size={{ xs: 6 }}>
                <Button>  Sube Tu Logo Post Razon Social</Button>
                <Divider/>
                <UploadButtonField onChange={uploadFileLogoPost} accept={'image/*'} name={e_logo_post_rz_company.name} label={e_logo_post_rz_company.label} text={'Subir Archivo'} />
                
                {
                    formikProps.values.logoPostRazonSocialCompanyChange 
                       ?
                        <>
                          <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                            <Card sx={{ maxWidth: 350, marginTop: 7 }}>
                              <CardActionArea>
                                <CardMedia
                                  component="img"
                                  height="250"
                                  sx={{ objectFit: 'fill' }}
                                  image={preview_rz_post}
                                  alt="green iguana"
                                />
                              </CardActionArea>
                            </Card>
                          </div>
                          <Card variant="elevation" sx={{  marginTop: 1.5, padding: 1, height: '70%',  }}>
                            <LinearProgressWithLabel percentage={percentage_rz_upload_post} label={formikProps.values.e_logo_post_rz_company.name} hasIcon={false} />
                          </Card>
                        </>
                       :
                        <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                          <CardActionImage urlImage={formikProps.values.e_logo_post_rz_company} typeImage={'company'} />
                        </div>
                }
            </Grid>
        </Grid>
    </div> 
  )
}
